import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../../core/user.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) { }

  canActivate(): boolean | UrlTree {
    return this.userService.hasTokenValid() ? this.router.createUrlTree(['/dashboard']) : true;
  }
}
